import { createFileRoute } from "@tanstack/react-router";
import {
  COMMERCIAL_CASE_STUDIES_PATH,
  COMMERCIAL_CASE_STUDIES_TITLE,
  LpCommercialCaseStudies,
} from "@/components/landing/lp-commercial-case-studies";
import { breadcrumbJsonLdScript, commercialBreadcrumbTrail } from "@/lib/breadcrumbs";
import { pageSeo, serviceJsonLdScript } from "@/lib/seo";
import { SITE } from "@/lib/site";

const DESCRIPTION =
  "Commercial and framework project case studies from CRS Energy. Register interest or request references for your sector.";

export const Route = createFileRoute("/commercial-case-studies")({
  head: () => ({
    ...pageSeo({
      path: COMMERCIAL_CASE_STUDIES_PATH,
      title: `${COMMERCIAL_CASE_STUDIES_TITLE} | Framework Programmes | CRS Energy`,
      description: DESCRIPTION,
      ogType: "article",
    }),
    scripts: [
      serviceJsonLdScript({
        name: COMMERCIAL_CASE_STUDIES_TITLE,
        description: DESCRIPTION,
        serviceType: "Commercial Case Studies",
        url: `${SITE.url}${COMMERCIAL_CASE_STUDIES_PATH}`,
      }),
      breadcrumbJsonLdScript(
        commercialBreadcrumbTrail(COMMERCIAL_CASE_STUDIES_TITLE, COMMERCIAL_CASE_STUDIES_PATH),
      ),
    ],
  }),
  component: () => <LpCommercialCaseStudies />,
});
